const main = {
  BAND: {
    address: '0xba11d00c5f74255f56a5e366f4f77f5a186d7f55',
    code: 'BAND',
    decimal: 18,
    name: 'Band Token'
  },
  BAT: {
    address: '0x0d8775f648430679a709e98d2b0cb6250d2887ef',
    code: 'BAT',
    decimal: 18,
    name: 'Basic Attention Token'
  },
  COMP: {
    address: '0xc00e94cb662c3520282e6f5717214004a7f26888',
    code: 'COMP',
    decimal: 18,
    name: 'Compound'
  },
  DAI: {
    address: '0x6b175474e89094c44da98b954eedeac495271d0f',
    code: 'DAI',
    decimal: 18,
    name: 'DAI'
  },
  ETH: {
    address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
    code: 'ETH',
    decimal: 18,
    name: 'Ethereum'
  },
  KNC: {
    address: '0xdd974d5c2e2928dea5f71b9825b8b646686bd200',
    code: 'KNC',
    decimal: 18,
    name: 'KyberNetwork'
  },
  LINK: {
    address: '0x514910771af9ca656af840dff83e8264ecf986ca',
    code: 'LINK',
    decimal: 18,
    name: 'Chain Link'
  },
  LRC: {
    address: '0xbbbbca6a901c926f240b89eacb641d8aec7aeafd',
    code: 'LRC',
    decimal: 18,
    name: 'Loopring'
  },
  MKR: {
    address: '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2',
    code: 'MKR',
    decimal: 18,
    name: 'Maker'
  },
  OMG: {
    address: '0xd26114cd6ee289accf82350c8d8487fedb8a0c07',
    code: 'OMG',
    decimal: 18,
    name: 'OmiseGO'
  },
  SNX: {
    address: '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f',
    code: 'SNX',
    decimal: 18,
    name: 'Synthetix Network'
  },
  USDC: {
    address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    code: 'USDC',
    decimal: 6,
    name: 'USD Coin'
  },
  USDT: {
    address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    code: 'USDT',
    decimal: 6,
    name: 'Tether USD'
  },
  WBTC: {
    address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
    code: 'WBTC',
    decimal: 8,
    name: 'Wrapped BTC'
  },
  ZRX: {
    address: '0xe41d2489571d322189246dafa5ebde1f4699f498',
    code: 'ZRX',
    decimal: 18,
    name: '0x Protocol'
  },
  UNI: {
    address: '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984',
    code: 'UNI',
    decimal: 18,
    name: 'Uniswap'
  },
  SUSHI: {
    address: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2',
    code: 'SUSHI',
    decimal: 18,
    name: 'Sushi Token'
  },
  AAVE: {
    address: '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9',
    code: 'AAVE',
    decimal: 18,
    name: 'Aave Token'
  },
  YFI: {
    address: '0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e',
    code: 'YFI',
    decimal: 18,
    name: 'yearn.finance'
  },
  AXS: {
    address: '0xbb0e17ef65f82ab018d8edd776e8dd940327b28b',
    code: 'AXS',
    decimal: 18,
    name: 'Axie Infinity Shard'
  },
  SLP: {
    address: '0xCC8Fa225D80b9c7D42F96e9570156c65D6cAAa25',
    code: 'SLP',
    decimal: 0,
    name: 'Smooth Love Potion'
  },
  ILV: {
    address: '0x767fe9edc9e0df98e07454847909b5e959d7ca0e',
    code: 'ILV',
    decimal: 18,
    name: 'Illuvium Token'
  },
  SHIB: {
    address: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
    code: 'SHIB',
    decimal: 18,
    name: 'SHIBA INU Token'
  },
  FTM: {
    address: '0x4E15361FD6b4BB609Fa63C81A2be19d873717870',
    code: 'FTM',
    decimal: 18,
    name: 'Fantom Token'
  },
  DYDX: {
    address: '0x92d6c1e31e14520e676a687f0a93788b716beff5',
    code: 'DYDX',
    decimal: 18,
    name: 'dYdX Token'
  },
  GALA: {
    address: '0x15D4c048F83bd7e37d49eA4C83a07267Ec4203dA',
    code: 'GALA',
    decimal: 8,
    name: 'Gala Token'
  },
  MANA: {
    address: '0x0F5D2fB29fb7d3CFeE444a200298f468908cC942',
    code: 'MANA',
    decimal: 18,
    name: 'Decentraland Token'
  },
  SAND: {
    address: '0x3845badAde8e6dFF049820680d1F14bD3903a5d0',
    code: 'SAND',
    decimal: 18,
    name: 'SAND Token'
  },
  APE: {
    address: '0x4d224452801ACEd8B2F0aebE155379bb5D594381',
    code: 'APE',
    decimal: 18,
    name: 'ApeCoin'
  },
  ENJ: {
    address: '0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c',
    code: 'ENJ',
    decimal: 18,
    name: 'EnjinCoin'
  },
  USDP: {
    symbol: 'USDP',
    name: 'Pax Dollar',
    address: '0x8E870D67F660D95d5be530380D0eC0bd388289E1',
    decimals: 18
  },
  GNO: {
    symbol: 'GNO',
    name: 'Gnosis',
    address: '0x6810e776880C02933D47DB1b9fc05908e5386b96',
    decimals: 18
  },
  MATIC: {
    symbol: 'MATIC',
    name: 'Matic Token',
    address: '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0',
    decimals: 18
  },
  WFLOW: {
    symbol: 'WFLOW',
    name: 'Wrapped Flow',
    address: '0x5c147e74D63B1D31AA3Fd78Eb229B65161983B2b',
    decimals: 18
  },
  HT: {
    symbol: 'HT',
    name: 'HuobiTokenHuobiToken',
    address: '0x6f259637dcD74C767781E37Bc6133cd6A68aa161',
    decimals: 18
  },
  GRT: {
    symbol: 'GRT',
    name: 'Graph Token',
    address: '0xc944E90C64B2c07662A292be6244BDf05Cda44a7',
    decimals: 18
  }
}

const kovan = {
  ETH: {
    address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
    name: 'Ethereum',
    code: 'ETH',
    decimal: 18
  },
  'DAI-UNI': {
    address: '0x4C38cDC08f1260F5c4b21685654393BB1e66a858',
    name: 'Dai (Uniswap)',
    code: 'DAI-UNI',
    decimal: 18
  },
  'MKR-UNI': {
    address: '0xaC94Ea989f6955C67200DD67F0101e1865A560Ea',
    name: 'Maker (Uniswap)',
    code: 'MKR-UNI',
    decimal: 18
  },
  'DAI-KYBER': {
    address: '0xC4375B7De8af5a38a93548eb8453a498222C4fF2',
    name: 'Dai (KyberNetwork)',
    code: 'DAI-KYBER',
    decimal: 18
  },
  'MKR-KYBER': {
    address: '0xAaF64BFCC32d0F15873a02163e7E500671a4ffcD',
    name: 'Maker (KyberNetwork)',
    code: 'MKR-KYBER',
    decimal: 18
  }
}

export default { main, kovan }



// WEBPACK FOOTER //
// ./src/constants/tokensInfo.js